import type { Editor, Element } from 'slate';

import {
  bookmarkEndType,
  bookmarkStartType,
  breakType,
  cannedFieldType,
  checkboxType,
  drawingType,
  dynamicBlockType,
  dynamicInlineType,
  inputFieldType,
  instructionFieldElementType,
  isAlineElement,
  isCheckboxOptionFieldElement,
  isInlineInstructionFieldElement,
  suggestionMarkerEndType,
  suggestionMarkerStartType,
  tabType,
} from '../internal';

export function withVoids<T extends Editor>(editor: T): T {
  const { isVoid } = editor;

  editor.isVoid = (element: Element): boolean => {
    if (!isAlineElement(element)) return false;

    switch (element.type) {
      case dynamicBlockType:
      case dynamicInlineType: {
        const { triggerIndex } = element;

        return triggerIndex === 'not-set';
      }
      case inputFieldType:
        return !isCheckboxOptionFieldElement(element);
      case cannedFieldType:
      case breakType:
      case checkboxType:
      case drawingType:
      case tabType:
      case bookmarkStartType:
      case bookmarkEndType:
      case suggestionMarkerStartType:
      case suggestionMarkerEndType:
        return true;
      case instructionFieldElementType:
        return isInlineInstructionFieldElement(element);
      default:
        return isVoid(element);
    }
  };

  return editor;
}
